import {defineStore} from "pinia";
import {computed, ref, watch} from "vue";
import {resolveUnref, useAsyncState, useEventBus, useStorage} from "@vueuse/core";
import {Task, TaskFilter} from "../models/task";
import {useTasks} from "../composables/task";
import {taskKey} from "../util/events";
import {useRoute} from "vue-router";
import {useRouteQuery} from "@vueuse/router";

export const useTaskStore = defineStore('tasks', () => {
    const route = useRoute()
    const filters = useStorage<Map<number, TaskFilter>>('filters', new Map())
    const page = useRouteQuery('page', '1', {transform: Number})
    const taskEvent = useEventBus(taskKey)
    const projectId = computed(() => Number(route.params.projectId))
    const {state, isReady, isLoading, execute} = useAsyncState<{ tasks: Task[], maxPages: number }>(async () => {
            const filter: TaskFilter = resolveUnref(filters).get(resolveUnref(projectId)) ?? {
                searchQuery: null,
                sortBy: "priority",
                direction: "ASC",
                performers: [],
                types: [],
                labels: [],
                start: null,
                end: null,
                size: 50,
                status: null
            };
            const {data} = await useTasks(projectId, page.value - 1, filter)
            return {tasks: data.value?.content ?? [], maxPages: data.value?.totalPages ?? -1}
        },
        {tasks: [], maxPages: -1},
    )
    taskEvent.on((event: string) => {
        if (event === 'refresh') {
            execute()
        }
    })
    watch(page, val => {
        if (val) {
            execute()
        }
    })
    watch(projectId, val => {
        if (val) {
            execute()
        }
    })
    const tasks = computed(() => state.value.tasks)
    const maxPages = computed(() => state.value.maxPages)
    return {tasks, maxPages, execute, isLoading, isReady, filters}
})
